/* eslint-disable @typescript-eslint/no-unused-vars */
import { useColorMode, useTheme } from '@tonic-one/react';

export function useFlexContainerStyle() {
  const [colorMode] = useColorMode();
  const { colors } = useTheme();
  const flexContainerColor = {
    light: colors['gray:60'],
    dark: colors['gray:60'],
  }[colorMode];
  const flexContainerStyle = {
    appearance: 'none',
    border: '0.0625rem solid',
    outline: 0,
    position: 'relative',
    transition: 'all .2s',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingTop: '12px',
    paddingBottom: '5px',
    // width: '100%',
    backgroundColor: 'transparent',
    borderColor: flexContainerColor,
    overflow: 'auto',
  };
  return flexContainerStyle;
}
export function useTreeStyle() {
  return { height: '300px' };
}
